import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {BaseService} from "@secca/core/services/base.service";
import {SettingsService} from "@secca/core/services/settings.service";

@Injectable({
  providedIn: 'root'
})
export class UploadCaseFileService extends BaseService  {
  private basePath = 'coordinationcase/file';

  constructor(private http: HttpClient,
              private settingsService: SettingsService) {
    super(settingsService)
  }

  uploadFile(supplierInvoiceId: number, linkedCaseId: number, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.http.post(this.baseURL+this.basePath+'/'+supplierInvoiceId+'/'+linkedCaseId, formData, {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    });
  }

  deleteFile(supplierInvoiceId: number, docId: string): Observable<any> {
    return this.http.delete(this.baseURL+this.basePath+'/'+supplierInvoiceId+'/'+docId, {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      })
    });
  }

  getFile(docId: string): Observable<any> {
    return this.http.get(this.baseURL+this.basePath+'/'+docId, {
      responseType: 'blob'
    });
  }
}
